import { useMemo } from 'react';
import { createPortal } from 'react-dom';

const elementMap = new Map();

/**
 * @param {{
 *   element: Element|string; 
 * }} param0 
 */
const Portal = ({
  element,
  children,
}) => {
  const el = useMemo(() => {
    if (typeof element !== 'string') return element;

    // Checking if we already have the element in cache
    if (!elementMap.has(element)) {
      const el = document.querySelector(element);
      elementMap.set(el);
      return el
    }

    return elementMap.get(element);
  }, [element]);

  return createPortal(children, el);
}

export default Portal;